/**
 * Tema compartilhado dos gráficos MUI X Charts na Inteligência de Mercado.
 *
 * As cores referenciam os tokens `--ds-*` (definidos em index.css como tripletos RGB),
 * então os gráficos seguem automaticamente o tema Dark/Light sem JS de sincronização —
 * basta a CSS var mudar. Usado como `colors={DS_CATEGORICAL}` e `sx={chartSx}`.
 */

/** Paleta categórica (donut de modalidades, barras por UF, etc.). */
export const DS_CATEGORICAL = [
  'rgb(var(--ds-brand))',
  'rgb(var(--ds-info))',
  'rgb(var(--ds-success))',
  'rgb(var(--ds-warning))',
  'rgb(var(--ds-danger))',
  'rgb(var(--ds-brand-hover))',
  'rgb(var(--ds-brand-subtle))',
];

export const DS_BRAND = 'rgb(var(--ds-brand))';
export const DS_SUCCESS = 'rgb(var(--ds-success))';
export const DS_TEXT2 = 'rgb(var(--ds-text-secondary))';
export const DS_BORDER = 'rgb(var(--ds-border))';

/** sx comum: pinta eixos, labels e legenda com os tokens do tema. */
export const chartSx = {
  '& .MuiChartsAxis-tickLabel': { fill: `${DS_TEXT2} !important` },
  '& .MuiChartsAxis-label': { fill: `${DS_TEXT2} !important` },
  '& .MuiChartsAxis-line': { stroke: `${DS_BORDER} !important` },
  '& .MuiChartsAxis-tick': { stroke: `${DS_BORDER} !important` },
  '& .MuiChartsLegend-series text': { fill: `${DS_TEXT2} !important` },
} as const;

/** Coage NUMERIC do Postgres (vem como string) para número seguro. */
export const num = (v: number | string | null | undefined): number => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};
